/**
 * @name NextPager
 * @interface
 */

/**
 * Gives least page number not loaded
 * @implements NextPager
 */
export class LeastNextPager {
  /**
   * @param {Object.<number,boolean>} [pagesLoaded]
   * @param {number} [totalPages]
   * @return number|undefined
   */
  next(pagesLoaded, totalPages) {
    if (totalPages === 0 || pagesLoaded > totalPages) {
      return;
    }
    let result = 1;
    if (pagesLoaded) {
      while (pagesLoaded[result]) {
        ++result;
      }
    }
    return result;
  }
}

export default LeastNextPager;
